import { get} from 'api/requests';
import { urlNotifications } from 'api';

  export const notificationsBilling = async () => {
    try {
      const { data } = await get(`${urlNotifications}/billing`);
      return data || [];
    } catch (error) {
      return [];
    }
  }
  